import CanvasJSReact from '@canvasjs/react-charts';
import moment from 'moment';
import './Chart.css';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export default function Chart_ReportMonthly({ info, xlabel, solorpower, gridpower, ens, irr }) {
    const plot = [
        { color: '#E74C3C', unit: 'kW', name: 'Grid Power', dp: 3 },
        { color: "#5DE622", unit: 'kW', name: 'Solar Power', dp: 3 },
        { color: "#566573", unit: 'kW', name: 'Energy not Supply (P)', dp: 3 },
        { color: "#F1C40F", unit: 'W/m<sup>2</sup>', name: 'Irradiation', dp: 3 },
    ]

    const options = {
        height: 326,
        zoomEnabled: true,
        toolTip: {
            shared: true,
            borderColor: 'rgba(204, 204, 220, 0.12)',
            borderThickness: 1,
            cornerRadius: 2,
            contentFormatter: function (e) {
                if (window.screen.width < 576) {
                    return null
                }
                if (e.entries[0].dataPoint !== undefined) {
                    var elem = '<p style = "font-family: Inter !important;font-size: 12px !important;margin-bottom:0px;color: black !important;">TimeStamp : ' + moment(new Date(e.entries[0].dataPoint.x)).add(0, 'days').format('DD MMM YYYY HH:mm') + '</p>'
                    elem += '<div class="measure-table" style = "font-family: Inter !important;margin-top:0px;">'
                    for (let i = 0; i < e.entries.length; i++) {
                        if (e.entries[i].dataPoint.y !== undefined) {
                            const sname = e.entries[i].dataSeries.name
                            const filtered = plot.filter(item => item.name === sname);
                            if (filtered.length > 0) {
                                var value = ""
                                if (e.entries[i].dataPoint.y !== 0) {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: filtered[0].dp, maximumFractionDigits: filtered[0].dp })
                                } else {
                                    value = e.entries[i].dataPoint.y.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                }
                                elem += '<div class="measure-rows font-bold">' +
                                    '<div class="measure-cell" style = "color:' + filtered[0].color + ';font-size: 11px !important;min-width:150px  !important;">' + e.entries[i].dataSeries.name + '</div>' +
                                    '<div class="measure-cell numberright"  style = "padding-right:8px;font-size: 11px !important;color: black !important;">' + value + '</div>' +
                                    '<div class="measure-cell" style = "width:30px;font-size: 11px !important;color: black !important;">' + filtered[0].unit + '</div>' +
                                    '</div>'
                            }
                        }
                    }
                    elem += '</div>'
                    return elem
                }
            }
        },
        responsive: true,
        backgroundColor: "#fff",
        xValueType: 'dateTime',
        animationEnabled: true,
        title: {
            text: info?.SiteName,
            fontSize: 14,
            fontFamily: 'poppins',
            fontWeight: 'normal',
            horizontalAlign: "center"
        },
        legend: {
            fontFamily: 'poppins',
            fontSize: 10,
            fontWeight: 'normal',
            cursor: "pointer",
            fontColor: '#000',
            horizontalAlign: "center", // "center" , "right"
            verticalAlign: "top",  // "top" , "bottom"
        },
        axisX: {
            interval: 1,
            intervalType: "hour",
            labelFormatter: function (e) {
                return moment(new Date(e.value)).format('HH:mm')
            },
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'bold',
            labelFontFamily: 'poppins',
            labelFontSize: 10,
            title: xlabel,
            margin: -5,
        },
        axisY: [{
            //  title: 'Power (kW)',
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "poppins",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "#AEB6BF",
            minimum: 0,
        }],
        axisY2: [{
            //  title: 'Irradiantion (Wh/m2)',
            titleFontFamily: 'poppins',
            titleFontSize: 12,
            titleFontWeight: 'normal',
            titleFontColor: '#2C3E50',
            labelFontFamily: "poppins",
            labelFontSize: 10,
            labelFontWeight: 'normal',
            labelFontColor: '#2C3E50',
            gridDashType: "dash",
            gridColor: "rgba(204, 204, 220, 0.12)",
        }],
        data: [{
            type: "area",
            showInLegend: true,
            legendMarkerType: "square",
            name: 'Grid Power',
            color: "#E74C3C",
            markerType: "none",
            axisYIndex: 1,
            dataPoints: gridpower,
            fillOpacity: 0.9,
            lineThickness: 3,
        },
        {
            type: "area",
            showInLegend: true,
            legendMarkerType: "square",
            name: 'Solar Power',
            color: "#5DE622",
            markerType: "none",
            axisYIndex: 0,
            dataPoints: solorpower,
            fillOpacity: 0.7,
            lineThickness: 3,
        }, {
            type: "area",
            showInLegend: true,
            legendMarkerType: "square",
            name: 'Energy not Supply (P)',
            color: "#566573",
            markerType: "none",
            axisYIndex: 0,
            dataPoints: ens,
            fillOpacity: 0.8,
            lineThickness: 3,
        }, {
            type: "line",
            showInLegend: true,
            name: 'Irradiation',
            axisYType: "secondary",
            color: "#F1C40F",
            markerType: "none",
            axisYIndex: 1,
            dataPoints: irr,
            lineThickness: 2,
        }]
    }

    return (
        <div className="dashboard-chart-wrapper">
            <CanvasJSChart options={options}
            />
        </div>
    );

}

